import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  merchantAdminRouter: Array<RouteRecordRaw> = [
    {
        path: '/merchant-admin',
        name: '商户后台管理',
        component: Layout,
        redirect: '/merchant-admin/order-list',
        meta: { title: '商户后台管理', icon: 'icon-shop', alwaysShow: true },
        children: [
            {
                path: 'order-list',
                name: '商户订单列表',
                component: () => import('@/views/merchant-admin/OrderList.vue'),
                meta: { title: '商户订单列表', keepAlive: true, depth: 30, badge: 'unSolveOrder' }
            },
            {
                path: 'order-edit',
                name: '商户订单编辑',
                component: () => import('@/views/merchant-admin/OrderEdit.vue'),
                meta: { title: '商户订单编辑', depth: 40 }
            },
            {
                path: 'product-list',
                name: '商品管理',
                component: () => import('@/views/merchant-admin/ProductList.vue'),
                meta: { title: '商品管理', 
                        keepAlive: true, 
                        v:2,//商户端
                        depth: 30 }
            },
            {
                path: 'product-edit',
                name: '商品编辑',
                component: () => import('@/views/merchant-admin/ProductEdit.vue'),
                meta: { title: '商品编辑', depth: 40 }
            },
            {
                path: 'product-edit-old',
                name: '商品编辑-旧',
                component: () => import('@/views/merchant-admin/ProductEditOld.vue'),
                meta: { title: '商品编辑-旧', depth: 40 }
            },
            // {
            //     path: 'product-edit',
            //     name: '商品查看',
            //     component: () => import('@/views/merchant-admin/ProductEdit.vue'),
            //     meta: { title: '商品查看', depth: 40 }
            // },
            {
                path: 'coupon-product-view',
                name: '电子券商品查看',
                component: () => import('@/views/merchant-admin/CouponProductDetail.vue'),
                meta: { title: '电子券商品详情', depth: 40 }
            },
            {
                path: 'coupon-product-edit',
                name: '电子券商品编辑',
                component: () => import('@/views/merchant-admin/CouponProductDetail.vue'),
                meta: { title: '电子券商品详情', depth: 40 }
            },
            {
                path: 'product-check-list',
                name: '商品审核列表',
                component: () => import('@/views/merchant-admin/ProductCheckList.vue'),
                meta: { title: '商品审核列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'product-check-list-old',
                name: '商品审核列表-旧',
                component: () => import('@/views/merchant-admin/ProductCheckListOld.vue'),
                meta: { title: '商品审核列表-旧', keepAlive: true, depth: 30 }
            },
            {
                path: 'fine-list',
                name: '罚款订单列表',
                component: () => import('@/views/merchant-admin/FineList.vue'),
                meta: { title: '罚款订单列表', depth: 30 }
            },
            {
                path: 'voucher-list',
                name: '核销管理',
                component: () => import('@/views/merchant-admin/VoucherList.vue'),
                meta: { title: '核销管理', keepAlive: true, depth: 30 }
            },
            {
                path: 'reconcile-list',
                name: '商户对账列表',
                component: () => import('@/views/merchant-admin/ReconcileList.vue'),
                meta: { title: '商户对账列表', keepAlive: true, depth: 30, badge: 'shopduizhang', withoutNum: true }
            },
            {
                path: 'reconcile-order-list',
                name: '对账订单列表',
                component: () => import('@/views/merchant-admin/ReconcileOrderList.vue'),
                meta: { title: '对账订单列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'shop_reconciliation-list',
                name: '商家对账管理',
                component: () => import('@/views/invoice/ShopReconciliationList.vue'),
                meta: { title: '商家对账', keepAlive: true, depth: 30 }
            },
            {
                path: 'shop_reconciliation-detail',
                name: '商家对账详情查看',
                component: () => import('@/views/invoice/ShopReconciliationEdit.vue'),
                meta: { title: '商家对账详情' }
            },
            {
                path: 'off-product-list',
                name: '下架商品列表',
                component: () => import('@/views/merchant-admin/OffProductList.vue'),
                meta: { title: '下架商品列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'invoice-list',
                name: '发票列表',
                component: () => import('@/views/merchant/InvoiceList.vue'),
                meta: {
                    title: '发票列表',
                    v: 1,   // 商户端
                    keepAlive: true,
                    depth: 30
                }
            },
            {
                path: 'invoice-edit',
                name: '发票编辑',
                component: () => import('@/views/merchant/InvoiceEdit.vue'),
                meta: { title: '发票编辑', depth: 40 }
            },
            {
                path: 'shop-list',
                name: '门店列表',
                component: () => import('@/views/merchant/ShopList.vue'),
                meta: { title: '门店管理', keepAlive: true, depth: 30 }
            },
            {
                path: 'shop-edit',
                name: '门店编辑',
                component: () => import('@/views/merchant/ShopEdit.vue'),
                meta: { title: '门店编辑' }
            },
            {
                path: 'shop-confirm',
                name: '门店批量上传列表',
                component: () => import('@/views/merchant/ShopConfirm.vue'),
                meta: { title: '门店批量上传列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'workorder',
                name: '商户工单列表',
                component: () => import('@/views/merchant-admin/WorkOrderList.vue'),
                meta: { title: '工单列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'workorder-edit',
                name: '商户工单编辑',
                component: () => import('@/views/merchant-admin/WorkOrderEdit.vue'),
                meta: { title: '工单编辑' }
            },
            {
                path: 'bind-list',
                name: '账号绑定列表',
                component: () => import('@/views/merchant-admin/BindList.vue'),
                meta: { title: '账号绑定列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'stock-list',
                name: '库存管理',
                component: () => import('@/views/merchant-admin/StockList.vue'),
                meta: { title: '库存管理', keepAlive: true, depth: 30 }
            },
            {
                path: 'bad-list',
                name: '差评订单列表',
                component: () => import('@/views/merchant-admin/BadOrderList.vue'),
                meta: { title: '差评订单列表'}
            },
            {
                path: 'sale-list',
                name: '销售额列表',
                component: () => import('@/views/merchant-admin/SaleList.vue'),
                meta: { title: '销售额列表', depth: 30 }
            },
            {
                path: 'product-cats-list',
                name: '商品分类列表',
                component: () => import('@/views/merchant-admin/ProductCatsList.vue'),
                meta: { title: '商品分类列表'}
            },
            {
                path: 'product-cat-sort',
                name: '三级分类商品排序',
                component: () => import('@/views/merchant-admin/CatProductEditSort.vue'),
                meta: { title: '三级分类商品排序' }
            },
            {
                path: 'reconciliation-list',
                name: '商户对账',
                component: () => import('@/views/merchant-admin/ReconciliationList.vue'),
                meta: { title: '商户对账' }
            },
            {
                path: 'reconciliation-detail',
                name: '商户对账详情',
                component: () => import('@/views/merchant-admin/ReconciliationEdit.vue'),
                meta: { title: '商户对账详情' }
            },
            { path: 'spring-rule-list',
                name: '配规列表',
                component: () => import('@/views/merchant-admin/SpringRuleList.vue'),
                    meta: { title: '配规列表',
                    v: 1,   // 商户端
                }
            },
            {
                path: 'spring-rule-edit',
                name: '春节配规编辑',
                component: () => import('@/views//merchant-admin/SpringRuleEdit.vue'),
                meta: { title: '春节配规编辑', depth: 40 }
            },
            { path: 'special-rule-list',
                name: '特殊配规列表',
                component: () => import('@/views/merchant-admin/special-rules/SpecialRuleList.vue'),
                meta: { title: '特殊配规', keepAlive: true, depth: 30, v: 1 }
            },
            {
                path: 'special-rule-edit',
                name: '特殊配规编辑',
                component: () => import('@/views/merchant-admin/special-rules/SpecialRuleEdit.vue'),
                meta: { title: '特殊配规编辑', depth: 40, v: 1 }
            },
            {
                path: 'shop-logo',
                name: '运营设置商城标识',
                component: () => import('@/views/merchant-admin/special-rules/ShopLogo.vue'),
                meta: { title: '运营设置商城标识', depth: 40, v: 1 }
            },
            {
                path: 'activity-list',
                name: '活动列表',
                component: () => import('@/views/merchant-admin/ActivityList.vue'),
                meta: { title: '活动提报' }
            },
            {
                path: 'activity-edit',
                name: '活动编辑',
                component: () => import('@/views/merchant-admin/ActivityEdit.vue'),
                meta: { title: '活动编辑'}
            },
            {
                path: 'product-view',
                name: '查看商品',
                component: () => import('@/views/merchant-admin/ActiveProductList.vue'),
                meta: { title: '查看商品' }
            },
            {
                path: 'auto-img',
                name: '生成商品详情图',
                component: () => import('@/views/merchant-admin/AutoDetailsImg.vue'),
                meta: { title: '生成商品详情图', depth: 50 }
            },
            {
                path: 'product-price-list',
                name: '商品比价',
                component: () => import('@/views/merchant-admin/ProductPriceComparisonList.vue'),
                meta: { title: '商品比价',keepAlive: true, }
            },
            {
                path: 'product-price-edit',
                name: '商品比价编辑',
                component: () => import('@/views/merchant-admin/ProductPriceComparisonEdit.vue'),
                meta: { title: '商品比价编辑', }
            },
            {
                path: 'refund-list',
                name: '特殊退款列表',
                component: () => import('@/views/merchant-admin/RefundOrderList.vue'),
                meta: { title: '特殊退款列表', KeepAlive: true }
            },
            {
                path: 'complaint-list',
                name: '投诉订单列表',
                component: () => import('@/views/merchant-admin/ComplaintOrderList.vue'),
                meta: { title: '投诉订单列表', KeepAlive: true }
            },
        ]
    }
]

export default  merchantAdminRouter;